import api from "@/shared/api";
import { useEffect, useState } from "react";


export function useAuth() {
    const [isAuth, setIsAuth] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("access_token");

        if (!token) {
            setIsAuth(false);
            setLoading(false);
            return;
        }

        api.get('/api/auth/check').then(res => {
            setIsAuth(true);
        }).catch(err => {
            setIsAuth(false);
            localStorage.removeItem("access_token");
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    return { isAuth, loading };
}